var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { usePopup } from "@/hooks/layout";
import { useLogger } from "@/utils/loggerService";
import { faCircleRadiation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default function Placeholder(_a) {
    var _this = this;
    var widget = _a.widget, events = _a.events;
    var _b = usePopup(), showPopup = _b.showPopup, closePopup = _b.closePopup;
    var logger = useLogger().logger;
    return (_jsxs("div", __assign({ className: "fixed inset-x-0 bottom-0 z-50 bg-transparent rounded-lg md:max-w-md md:relative" }, { children: [_jsxs("div", __assign({ className: "items-center md:flex" }, { children: [_jsx("div", __assign({ className: "flex items-center justify-center flex-shrink-0 w-16 h-16 mx-auto border border-gray-300 rounded-full" }, { children: _jsx(FontAwesomeIcon, { icon: faCircleRadiation, className: "w-8 h-8 text-[color:var(--colors-danger-outlinedColor)]" }) })), _jsxs("div", __assign({ className: "mt-4 text-center md:mt-0 md:ml-6 md:text-left" }, { children: [_jsxs("p", __assign({ className: "font-bold" }, { children: ["Delete your account ", widget.id] })), _jsx("p", __assign({ className: "mt-1 text-sm text-gray-700" }, { children: "You will lose all of your data by deleting your account. This action cannot be undone." })), _jsx("p", {})] }))] })), _jsxs("div", __assign({ className: "mt-8 mb-4 text-center md:text-right md:flex md:justify-end" }, { children: [_jsx("button", __assign({ className: "block button danger w-full px-4 py-3 text-sm font-semibold rounded-lg md:inline-block md:w-auto md:py-2 md:ml-2 md:order-2", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            var result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, showPopup({
                                            type: "dev/popup/confirm",
                                            payload: {
                                                title: "Demande de confirmation",
                                                content: "Supprimer le profile ?",
                                                buttons: {
                                                    confirm: "Valider mon choix",
                                                    cancel: "Revenir",
                                                },
                                            },
                                        })];
                                    case 1:
                                        result = _a.sent();
                                        if ((result === null || result === void 0 ? void 0 : result.reason) === "confirm") {
                                            closePopup(widget.id, "confirm", widget.slot);
                                        }
                                        logger.debug("[POPUP DEMO] - Popup widget Result: ", result);
                                        return [2 /*return*/];
                                }
                            });
                        }); } }, { children: "Delete Account" })), _jsx("button", __assign({ className: "block w-full px-4 py-3 mt-4 text-sm font-semibold bg-gray-200 rounded-lg md:inline-block md:w-auto md:py-2 md:mt-0 md:order-1 hover:text-gray-200 hover:bg-gray-600", onClick: function () {
                            closePopup(widget.id, "cancel", widget.slot);
                        } }, { children: "Cancel" }))] }))] })));
}
widgetsDictionary.register("dev/popup/delete/profile", {
    name: "Suppression du profil",
    display: Placeholder,
    selectable: false,
    editable: false,
});
